// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tips-container":"styles__tips-container___3e52W","tipsContainer":"styles__tips-container___3e52W","progress-wrapper":"styles__progress-wrapper___3MVjH","progressWrapper":"styles__progress-wrapper___3MVjH","color-blue":"styles__color-blue___23tzR","colorBlue":"styles__color-blue___23tzR","color-gray":"styles__color-gray___21cwD","colorGray":"styles__color-gray___21cwD"};
    if(module.hot) {
      // 1762804470096
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  